/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ListOrdered = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M5.75 3.5H4.72l-1.47.4v1.55l1-.27V8.5H3V10h4V8.5H5.75zM10 4h11v2H10zm0 7h11v2H10zm0 7h11v2H10zm-7.12-2.37a2.13 2.13 0 1 1 3.8 1.29L5.32 18.5H7V20H3v-1.12l2.47-2.84q.15-.17.16-.41a.62.62 0 0 0-1.25-.06l-.01.3h-1.5z" />
  </Icon>
);
